// extracted by mini-css-extract-plugin
export default {"pageWrap":"dc-z","fullWidth":"ec-z","heading":"fc-z","fullBleed":"gc-z","hidden":"hc-z"};